'use es6';

import http from 'hub-http/clients/apiClient';
import { formatWorkflowsPaged, formatWorkflows } from 'reference-resolvers/formatters/formatWorkflows';
const BASE_URL = 'automationapps/v1/summaries';
export const createGetWorkflowsByIds = ({
  httpClient
}) => ids => httpClient.get(BASE_URL, {
  query: {
    flowIds: ids
  }
}).then(resp => resp.results).then(formatWorkflows);
export const getWorkflowsByIds = createGetWorkflowsByIds({
  httpClient: http
});
export const makeCreateGetWorkflowsSearchPage = (flowObjectTypeId = null) => ({
  httpClient
}) => props => {
  const {
    count,
    offset,
    query
  } = props.toJS();
  const querystring = {
    name: query,
    limit: count,
    offset,
    objectTypeId: flowObjectTypeId
  };
  return httpClient.get(BASE_URL, {
    query: querystring
  }).then(formatWorkflowsPaged);
};
export const createGetWorkflowsSearchPage = makeCreateGetWorkflowsSearchPage();
export const getWorkflowsSearchPage = createGetWorkflowsSearchPage({
  httpClient: http
});